import { PkAvatar, PkIcon, PkIdentifier } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import type { LiveblogStarReporter } from '../utils';

import { useWindowSize } from '@hooks/useWindowSize';

import * as classes from './styles.module.scss';

export const StarReporter = ({ reporter }: { reporter: LiveblogStarReporter }) => {
  const { isDesktop } = useWindowSize();

  return (
    <PkIdentifier className={clsx(classes.lbReporter, classes.lbReporterStar, 'pk-py--0')}>
      <PkAvatar
        slot='prefix'
        className={classes.picture}
        type='image'
        title={reporter.person}
        src={reporter.imageUrl}
        fallbackImage='generic-head'
        size={isDesktop ? 40 : 32}
      >
        <div slot='badge' className={classes.icon}>
          <PkIcon className={classes.pkIcon} name='actions-followed-active' size={10} />
        </div>
      </PkAvatar>
      <span slot='primary' className={classes.name}>
        {reporter.person}
      </span>
      <span slot='secondary' className={classes.role}>
        {reporter.description}
      </span>
    </PkIdentifier>
  );
};

export default memo(StarReporter);
